import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration, ProtectedResourceScopes } from "@azure/msal-angular";

if (environment.production) {
  enableProdMode();
}

export function getBaseUrl() {
  
  if(sessionStorage.getItem('redirectUri') === null){
    const routeSegments = window.location.pathname.split('/');

    if(routeSegments.length > 2){
      sessionStorage.setItem('redirectUri', routeSegments.join('/'));
    }
    else if(window.location.href.includes('/?action=redirect')){
      sessionStorage.setItem('redirectUri', window.location.href);
    }

  }

  const isLocalhost = window.location.hostname === 'localhost';

  return isLocalhost ? 'http://localhost:4200/' : document.getElementsByTagName('base')[0].href;
}

function loggerCallback(logLevel: LogLevel, message: string) {
  if (!environment.production) {
    console.log("MSAL Angular: ", message);
  }
}

fetch(getBaseUrl() + 'api/configuration/auth')
  .then(response => response.json())
  .then(json => {
    platformBrowserDynamic([
      {
        provide: MSAL_INSTANCE, useValue: new PublicClientApplication({
          auth: {
            clientId: json.data.clientId,
            authority: 'https://login.microsoftonline.com/' + json.data.tenantId,
            redirectUri: getBaseUrl()
          },
          cache: {
            cacheLocation: "sessionStorage"
          },
          system: {
            loggerOptions: {
              loggerCallback,
              logLevel: LogLevel.Info,
              piiLoggingEnabled: false
            },
          }
        })
      },
      {
        provide: MSAL_GUARD_CONFIG, useValue: {
          interactionType: "redirect",
          authRequest: {
            "scopes": [
              "user.read"
            ]
          }
        } as MsalGuardConfiguration
      },
            {
        provide: MSAL_INTERCEPTOR_CONFIG, useValue: {
          interactionType: "redirect",
          protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>(
            (json.data.protectedResourceMaps || []).flatMap((resource: any) => [
              [
                resource.endpoint,
                [
                  {
                    httpMethod: "GET",
                    scopes: resource.scopes.read,
                  },
                  {
                    httpMethod: "POST",
                    scopes: resource.scopes.write,
                  },
                  {
                    httpMethod: "DELETE",
                    scopes: resource.scopes.write,
                  }
                ]
              ]
            ])
          ),
        } as MsalInterceptorConfiguration
      },
      {
        provide: 'BASE_URL',
        useFactory: getBaseUrl,
      }
    ])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });


